import React from 'react';
import InputPassword from "vendor/react-ux-password-field/src"
import TermsAndConditionsModal from "./termsAndConditionsModal"
import DataUsageModal from "./dataUsageModal"

export const GetFirstName = props =>
  <div className="form-group">
    <label
      htmlFor="txtFirstName"
      className="control-label"
    >
      First Name *
    </label>
    <input
      id="txtFirstname"
      type="text"
      className="form-control"
      placeholder="Jane"
      spellCheck="false"
      maxLength={80}
      {...props.firstName}
    />
    {
      props.firstName.error && props.firstName.touched
        ? <div className="text-danger">{props.firstName.error}</div>
        : <div></div>
    }
  </div>

export const GetLastName = props =>
  <div className="form-group">
    <label
      htmlFor="txtLastName"
      className="control-label"
    >
      Last Name *
    </label>
    <input
      id="txtLasttname"
      type="text"
      className="form-control"
      placeholder="Doe"
      spellCheck="false"
      maxLength={80}
      {...props.lastName}
    />
    {
      props.lastName.error && props.lastName.touched
        ? <div className="text-danger">{props.lastName.error}</div>
        : <div></div>
    }
  </div>

export const GetPhone = props =>
  <div className="form-group">
    <label
      htmlFor="txtPhone"
      className="control-label"
    >
      Phone
    </label>
    <input
      id="txtPhone"
      type="tel"
      className="form-control"
      placeholder="111-111-1111"
      spellCheck="false"
      {...props.phone}
    />
    {
      props.phone.error && props.phone.touched
        ? <div className="text-danger">{props.phone.error}</div>
        : <div></div>
    }
  </div>

export const GetEmail = props =>
  <div className="form-group">
    <label
      htmlFor="txtEmail"
      className="control-label"
    >
      Email * <em>(please use your school district email account if you have one)</em>
    </label>
    <input
      id="txtEmail"
      type="email"
      className="form-control"
      placeholder="jane@example.com"
      spellCheck="false"
      {...props.email}
    />
    {
      props.email.error && props.email.touched
        ? <div className="text-danger" dangerouslySetInnerHTML={{__html: props.email.error}}></div>
        : <div></div>
    }
  </div>

export const GetPasword = props =>
  <div className="form-group">
    <label
      htmlFor="txtPassword"
      className="control-label"
    >
      Choose a password *
    </label>
    <InputPassword
      id="txtPassword"
      className="form-control"
      placeholder="thoo!mu3Da"
      autoComplete="off"
      minLength={8}
      toggleMask={false}
      {...props.password}
    />
    {
      props.password.error && props.password.touched
        ? <div className="text-danger" dangerouslySetInnerHTML={{__html: props.password.error}}></div>
        : <div></div>
    }
  </div>

export const GetOptIn = props =>
  <div
    className={
      props.optIn.error && props.optIn.touched
        ? "has-error"
        : ""
    }
  >
    <div className="checkbox">
      <label>
        <input
          type="checkbox"
          {...props.optIn}
        />
        {props.label}
      </label>
    </div>
    {
      props.optIn.error && props.optIn.touched
        ? <div className="text-danger">{props.optIn.error}</div>
        : <div></div>
    }
  </div>

export const GetTermsAccepted = props =>
  <div>
    <div className="checkbox">
      <label>
        <input
          type="checkbox"
          {...props.termsAccepted}
        />
        I accept the <a onClick={props.openTerms()}>Terms & Conditions </a>
        and <a onClick={props.openDataUsage()}>Data Usage Policy</a> <em>*</em>
      </label>
      <TermsAndConditionsModal
        showModal={props.showTermsAndConditionsModal}
        closeModal={() => props.closeTerms()}
      />
      <DataUsageModal
        showModal={props.showDataUsageModal}
        closeModal={() => props.closeDataUsage()}
      />
    </div>
  </div>

export const GetSchool = props =>
  <div>
    <div className="form-group">
      <label
        htmlFor="schoolTxt"
        className="control-label"
      >
        School *
      </label>
      <input
        id="schoolTxt"
        type="text"
        className="form-control"
        placeholder="Springfield Elementary"
        spellCheck="false"
        maxLength={80}
        {...props.school}
      />
    </div>
    {
      props.school.error && props.school.touched
        ? <div className="text-danger">{props.school.error}</div>
        : <div></div>
    }
  </div>

export const GetCity = props =>
  <div>
    <div className={"form-group"}>
      <label
        htmlFor="cityTxt"
        className="control-label"
      >
        City *
      </label>
      <input
        id="cityTxt"
        type="text"
        className="form-control"
        placeholder="Springfield"
        maxLength={80}
        {...props.cityOrMunicipality}
      />
    </div>
    {
      props.cityOrMunicipality.error && props.cityOrMunicipality.touched
        ? <div className="text-danger">{props.cityOrMunicipality.error}</div>
        : <div></div>
    }
  </div>

export const GetStatesOrProvince = props =>
  <div>
    <div className={"form-group"}>
      <label
        htmlFor="txtStateOrProvince"
        className="control-label"
      >
        State or Province *
      </label>
      <select id="txtStateOrProvince"
              className="form-control"
              {...props.stateOrProvince}>
        <option value=""> - Select State/Province - </option>
        {props.statesOrProvinces.map(item => {
          return (
            <option key={item.code} value={item.code}>{item.name}</option>
          );
        })}
      </select>
    </div>
    {
      props.stateOrProvince.error && props.stateOrProvince.touched
        ? <div className="text-danger">{props.stateOrProvince.error}</div>
        : <div></div>
    }
  </div>

export const GetCountry = props =>
  <div>
    <div className={"form-group"}>
      <label
        htmlFor="txtCountry"
        className="control-label"
      >
        Country *
      </label>
      <select
        id="txtCountry"
        className="form-control"
        {...props.country}
      >
        <option value=""> - Select Country -</option>
        <option value="Canada">Canada</option>
        <option value="United States">United States</option>
        <option disabled> ────────── </option>
        {props.countries.map(item => {
          return (
            <option key={item} value={item}>{item}</option>
          );
        })}
      </select>
    </div>
    {
      props.country.error && props.country.touched
        ? <div className="text-danger">{props.country.error}</div>
        : <div></div>
    }
  </div>



// WEBPACK FOOTER //
// ./src/views/auth/registrationComponents.js